import { IonContent, IonPage, IonSpinner } from "@ionic/react";
import { FormattedMessage } from "react-intl";
import { Capacitor } from "@capacitor/core";

import styles from "./style.module.css";

const platform = () => Capacitor.getPlatform();

const getStoreUrl = () => {
  const plt = platform();
  if (plt === "ios") {
    return "https://apps.apple.com/app/id6475635950";
  }
  if (plt === "android") {
    return `https://play.google.com/store/apps/details?id=visito.app.production`;
  }
  return undefined;
};

export default function Maintenance({
  updateApp = false,
  remoteVersion,
}: {
  updateApp?: boolean;
  remoteVersion?: string;
}) {
  const storeUrl = getStoreUrl();

  const handleUpdate = () => {
    if (storeUrl) {
      window.open(storeUrl, "_system");
    } else {
      window.location.reload();
    }
  };

  return (
    <IonPage>
      <IonContent className="ion-padding ion-text-center" fullscreen>
        <div className={styles.maintenanceContainer}>
          <div className="logo-white" />
          <h1 className="mb-0">
            <FormattedMessage id={updateApp ? "home.updateApp": "home.maintenance"} />
          </h1>
          <p className={styles.description}>
            <FormattedMessage
              id={updateApp ? "home.updateApp.desc" : "home.maintenance.desc"}
              {...remoteVersion && { values: { remoteVersion } }}
            />
          </p>
          {updateApp ? (
            <button className={`btn ${styles.updateBtn}`} onClick={handleUpdate}>
              <FormattedMessage id="home.updateApp.btn" />
            </button>
          ) : (
            <IonSpinner
              name="circular"
              className="maintenance-spinner"
            />
          )}
        </div>
      </IonContent>
    </IonPage>
  );
};
